import BikeBanner from "@public/images/partners/Bike-banner.png";
const Banner = () => {
  return (
    <>
      <div>
        <img
          src={BikeBanner}
          style={{
            width: "100%",
            height: "270px"
          }}
        />
      </div>
    </>
  );
};

export default Banner;
